import(/* webpackMode: "eager" */ "/vercel/path0/src/app/invitation/[slug]/error.tsx");
